import { TOGGLE_STATE } from '../../../../common/GqlAPI';

const mutation = {
  toggleState: TOGGLE_STATE,
};

export { TOGGLE_STATE };

export { mutation };
